exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".root-copy-item[data-v-6fc3a573]{position:relative;width:24px;height:24px}.root-copy-item[data-v-6fc3a573],.root-copy-item .copied[data-v-6fc3a573]{display:flex;flex-direction:row;justify-content:flex-start;align-items:center}.root-copy-item .copied .copied-icon[data-v-6fc3a573]{fill:#1ec449;margin-right:4px}.root-copy-item .copied[data-v-6fc3a573]:hover{cursor:pointer}.root-copy-item .copied>span[data-v-6fc3a573]{position:absolute;bottom:100%;left:-6px;font-size:11px;line-height:12px;letter-spacing:.1px;color:#000}", ""]);

// exports
